module.exports = __webpack_public_path__ + "static/media/PIBKG_orange.f6290438.png";